import i18n from 'i18n'

export enum ExternAppointmentStatus {
  Pending = 1,
  Accepted = 2,
  Completed = 3,
  Finalized = 4,
  Canceled = 5,
}

export const externAppointmentStatusTypes = (): Record<ExternAppointmentStatus, string> => ({
  [ExternAppointmentStatus.Pending]: i18n.t('pending'),
  [ExternAppointmentStatus.Accepted]: i18n.t('accepted'),
  [ExternAppointmentStatus.Completed]: i18n.t('completed'),
  [ExternAppointmentStatus.Finalized]: i18n.t('finalized'),
  [ExternAppointmentStatus.Canceled]: i18n.t('canceled'),
})
